
<template>
    <input
      type="text"
      @focus="selectAll"
      :value="valor"
      @input="updateValue($event.target.value)"
      @blur="handleBlur"
      ref="valor"
      @keydown.esc="keyEsc"
      @keydown.enter="focusControl">
    <!-- <input
      type="text"
      @focus="selectAll"
      :value="valor"
      @input="updateValue(parseFloat($event.target.value) | 0)"
      @blur="handleBlur"
      ref="valor"
      @keydown.esc="keyEsc"
      @keydown.enter="focusControl"> -->
</template>

<script>
import { formatValue } from '../shared/utils'
import { SysVars } from '../main'
import { hasHiddenParent } from '../shared/utils';

export default {
    props: {
      value: { Number, String },
      currency: {
        type: String, default: '', required: false
      },
      max: {
        type: Number, default: Number.MAX_SAFE_INTEGER || 9007199254740991, required: false,
      },
      min: {
        type: Number, default: Number.MIN_SAFE_INTEGER || -9007199254740991, required: false
      },
      minus: {
        type: Boolean, default: false, required: false
      },
      precision: {
        type: Number, default: 0, required: false
      },
    },

    data () {
      return {
        valor: this.value,
        focused: false
      }
    },

    methods: {
      updateValue: function(value) {
        this.$emit('input', this.$strToFloat(value, this.precision))
      },

      handleBlur () {
        this.formatValue()
        this.$emit('blur')
      },

      formatValue: function() {
        let v = this.$refs.valor.value
        this.$refs.valor.value = formatValue(this.$strToFloat(v, this.precision), this.precision)
        this.focused = false
      },

      selectAll: function(event) {
        this.focused = true
        this.formatRemove()
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function() {
          event.target.select()
        }, 0)
      },

      formatRemove: function () {
        var vlr = this.$refs.valor.value
        this.$refs.valor.value = vlr.replace(/\./g, '')
      },

      focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }
          this.$emit('keyenter')
      },

      keyEsc(event) {
        this.$emit('keyesc', event)
      },

      focus: function () {
          if (this.$refs.valor) {
              let self = this
              this.$nextTick(function () {
                //const rect = this.$refs.pesquisa.getBoundingClientRect();
                self.$refs.valor.focus()
              })
          }
      },


    },

    watch: {
      value: function (value) {
        if (!this.focused) {
          this.$refs.valor.value = String(value).replace('.', ',')
          // console.log('inputvalue watch: ' + this.$refs.valor.value)
          this.formatValue()
        }
      }
    },

    mounted () {
      this.formatValue()
      // console.log('inputvalue mounted: ' + this.$refs.valor.value)
      // console.log('inputvalue mounted value: ' + this.value)
    },

    created () {
      // console.log('inputvalue created')
    },


}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-value.vue